function eXcell_clist2(a) {
    try {
        this.cell = a,
        this.grid = this.cell.parentNode.grid
    } catch (b) { }
    this.edit = function () {
        var choiceIdList = this.grid.getUserData(this.cell.parentNode.idd, "ChoiceIdLists");
        this.val = "";
        if (choiceIdList) {
            var parts = choiceIdList.split('||');
            this.val = parts[this.cell.cellIndex];
        }

        if (!this.val)
            this.val = "";
        var list = this.cell._combo || this.grid.clists2[this.cell._cellIndex];
        if (list) {
            this.obj = document.createElement("DIV");
            for (var values = this.val.split(","), e = "", c = 0; c < list.length; c++) {
                for (var isChecked = !1, f = 0; f < values.length; f++)
                    list[c].substring(0, list[c].indexOf("|")) == values[f] && (isChecked = !0);

                var label = list[c];
                var listVal = list[c];
                if (label.indexOf('|') != -1) {
                    listVal = label.substring(0, label.indexOf('|'));
                    label = label.substring(label.indexOf('|') + 1);
                }

                e += isChecked ? "<div><input type='checkbox' id='dhx_clist_" + c + "' checked='true' listvalue='" + listVal + "' /><label for='dhx_clist_" + c + "'>" + label + "</label></div>" : "<div><input type='checkbox' id='dhx_clist_" + c + "'  listvalue='" + listVal + "' /><label for='dhx_clist_" + c + "'>" + label + "</label></div>"
            }
            e += "<div><input type='button' value='" + (this.grid.applyButtonText || "Apply") + "' style='width:100px; font-size:8pt;' onclick='this.parentNode.parentNode.editor.grid.editStop();'/></div>";
            this.obj.editor = this;
            this.obj.innerHTML = e;
            document.body.appendChild(this.obj);
            this.obj.style.position = "absolute";
            this.obj.className = "dhx_clist";
            this.obj.onclick = function (a) {
                return (a || event).cancelBubble = !0
            }
            ;
            var h = this.grid.getPosition(this.cell);
            this.obj.style.left = h[0] + "px";
            this.obj.style.top = h[1] + this.cell.offsetHeight + "px";
            this.obj.getValue = function () {
                for (var c = "", d = 0; d < this.childNodes.length - 1; d++)
                    this.childNodes[d].childNodes[0].checked && (c && (c += ","),
                    c += jQuery(this.childNodes[d].childNodes[0]).attr('listvalue'));

                var choiceIdList = this.editor.grid.getUserData(this.editor.cell.parentNode.idd, "ChoiceIdLists");
                if (choiceIdList) {
                    var parts = choiceIdList.split('||');
                    parts[this.editor.cell.cellIndex] = c;
                    this.editor.grid.setUserData(this.editor.cell.parentNode.idd, "ChoiceIdLists", parts.join('||'));
                }

                for (var a = "", b = 0; b < this.childNodes.length - 1; b++)
                    this.childNodes[b].childNodes[0].checked && (a && (a += ","),
                    a += this.childNodes[b].childNodes[1].innerHTML);
                return a.replace(/&amp;/g, "&")
            }
        }
    }
    ;
    this.getValue = function () {
        var choiceIdList = this.grid.getUserData(this.cell.parentNode.idd, "ChoiceIdLists");
        var values = "";
        if (choiceIdList) {
            var parts = choiceIdList.split('||');
            values = parts[this.cell.cellIndex];
        }
        return this.cell._clearCell ? "" : values ? values : ""; //this.cell.innerHTML.toString()._dhx_trim().replace(/&amp;/g, "&")
    }
    ;
    this.detach = function () {
        if (this.obj)
            this.setValue(this.obj.getValue()),
            this.obj.editor = null,
            this.obj.parentNode.removeChild(this.obj),
            this.obj = null;
        return this.val != this.getValue()
    }
}
eXcell_clist2.prototype = new eXcell;
eXcell_clist2.prototype.setValue = function (a) {
    if (typeof a == "object") {
        var b = this.grid.xmlLoader.doXPath("./option", a);
        if (b.length)
            this.cell._combo = [];
        for (var d = 0; d < b.length; d++)
            this.cell._combo.push(b[d].firstChild ? b[d].firstChild.data : "");
        a = a.firstChild.data
    }
    a === "" || a === this.undefined ? (this.setCTxtValue(" ", a),
    this.cell._clearCell = !0) : (this.setCTxtValue(a),
    this.cell._clearCell = !1)
}
;
dhtmlXGridObject.prototype.registerCList2 = function (a, b) {
    if (!this.clists2)
        this.clists2 = [];
    typeof b != "object" && (b = b.split("||"));
    this.clists2[a] = b
}
;
